import {action, observable, toJS} from 'mobx';
import _ from 'lodash';

import api from './api';
import FormStore from "./FormStore";
import {excludedSignals} from "../constants/status";

class ShipmentStore {
  constructor(api) {
    this.shipmentDropoffForm = new FormStore(this);
    this.feedbackForm = new FormStore(this);

    this.feedbackForm.data = {
      stop_id: null,
      comment: '',
      rating: 0,
      tags: [],
    }
  }

  @observable driver = {};
  @observable shipments = {};
  @observable loadingShipments = false;
  @observable loadingShipment = false;
  @observable geocodingShipment = false;
  @observable loadingWarehouse = false;
  @observable searchingShipment = false;
  @observable activeShipment = {};
  @observable pageSize = 20;
  @observable ordering = {
    order_by: "id",
    desc: true
  };

  @observable selectShipmentId = null;
  @observable completedShipments = [];
  @observable inProgressShipments = [];
  @observable pendingShipments = [];
  @observable unroutedShipments = [];

  @observable statuses = [];
  @observable warehouses = [];
  @observable selectedWarehouse = -1;

  @observable downloadingCsv = false;

  @observable preFilled = false;
  @observable loadingModal = false;

  status_map = {
    CREATED: "CREATED",
    GEOCODE_FAILED: "ERRORED",
    GEOCODE_FAILED_PICKUP: "ERRORED",
    GEOCODE_FAILED_DROPOFF: "ERRORED",
    GEOCODED: "CREATED",
    ASSIGNED: "ASSIGNED",
    PICKUP_EN_ROUTE: "ON TIME",
    PICKUP_DELAY: "DELAYED",
    CANCELLED_BEFORE_PICKUP: "CANCELLED",
    PICKUP_READY: "ON TIME",
    PICKUP_FAILED: "FAILED",
    PICKUP_SUCCEEDED: "ON TIME",
    DROPOFF_EN_ROUTE: "ON TIME",
    DROPOFF_DELAY: "DELAYED",
    CANCELLED_AFTER_PICKUP: "CANCELLED",
    DROPOFF_READY: "ON TIME",
    DROPOFF_FAILED: "FAILED",
    DROPOFF_SUCCEEDED: "COMPLETED",
    RETURN_EN_ROUTE: "RETURNING",
    RETURN_DELAY: "RETURNING",
    RETURN_READY: "RETURNING",
    RETURN_FAILED: "FAILED",
    RETURN_SUCCEEDED: "RETURNED",
  };
  searchCriteria = {};
  filterDate;
  @observable serviceLevel;

  @action
  selectWarehouse(value) {
    this.selectedWarehouse = value;
  }

  refreshSearch(criteria) {
    this.searchCriteria = Object.assign({}, criteria)
    this.getShipments()
  }

  filterShipmentByStatus(statuses) {
    if (statuses && statuses.length > 0) {
      this.statuses = statuses;
      this.getShipments();
    } else if (this.statuses && this.statuses.length > 0) {
      this.statuses = [];
      this.getShipments();
    }
  }

  toggleOrder(field) {
    if (this.ordering.order_by === field) {
      this.ordering.desc = !this.ordering.desc;
    } else {
      this.ordering.order_by = field;
      this.ordering.desc = true;
    }

    this.getShipments();
  }

  // list shipments
  getShipments(page) {
    const qs = require('qs');
    this.loadingShipments = true;

    api.get('/shipments', this.processShipmentQuery(page), {
      'paramsSerializer': function(params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
      },
    }).then(response => {
        this.loadingShipments = false;
        this.shipments = response.data
      })
  }

  getWarehouses(cb) {
    this.loadingWarehouse = true;
    api.get('/warehouses')
      .then(response => {
        if (response.status === 200) {
          this.warehouses = response.data;
          // Selected when only one item.
          // if(response.data.length === 1) {
          //   this.selectedWarehouse = 0;
          // }
        }
        if(cb) {
          cb(response);
        }
        this.loadingWarehouse = false;
      })
  }

  saveWarehouse(wh, cb) {
    api.post('/warehouses', wh).then(response => {
      if (cb) cb(response);
    })
  }

  getClientSettings(callback) {
    api.get("/shipments/client-settings")
      .then(response => {
        if (response.status === 200) {
          if (callback) callback(response.data);
        }
      })
  }

  processShipmentQuery(page) {
    let query = Object.assign({page: page ? page : 1, pageSize: this.pageSize}, this.searchCriteria);
    query = Object.assign(query, this.ordering);
    if (this.statuses && this.statuses.length > 0) {
      query = Object.assign(query, {status: this.statuses});
    }

    if (this.filterDate) query['date'] = this.filterDate;
    if (this.serviceLevel) query['service_level'] = this.serviceLevel;

    return query;
  }

  getShipment(shipmentId, cb) {
    this.activeShipment = null;
    // getting from api
    return api.get('/shipments/' + shipmentId)
      .then(response => {
        this.loadingShipment = false;
        response.data.customer = _.merge(
          {name: '', email: '', phone_number: ''},
          response.data.customer
        );

        this.activeShipment = {
          error: false,
          data: response.data
        };

        if (response.ok && response.data.assignment_id) {
          this.driver = null
          api.get('/assignments/' + response.data.assignment_id)
            .then(response => {
              this.driver = {
                info: response.data?.driver,
                vehicle: response.data?.vehicle
              }
            })
        }
        if(cb) {
          cb(response);
        }
        return this.activeShipment
      })
  }

  getShipmentHistory() {
    if (!this.activeShipment || !this.activeShipment.data) {
      return;
    }
    // getting from api
    this.loadingHistory = true
    if (!this.activeShipment?.history)
      this.activeShipment.history = {}

    api.get('/shipments/' + this.activeShipment.data.id + '/history')
      .then(response => {
        this.loadingHistory = false;
        if (!this.activeShipment) return
        if (this.activeShipment.data && response.data.shipment && (this.activeShipment.data.id !== response.data.shipment.id)) {
          return;
        }
        this.activeShipment.history = response.data;
        this.activeShipment.history.outbound_events = response.data.outbound_events?.filter(s => !excludedSignals.includes( s.type + "." + s.signal ));
        this.activeShipment.history.ts = new Date()
        this.getShipmentTracking();
      });
  }

  getShipmentStops(callback) {
    if (!this.activeShipment || !this.activeShipment.data) {
      return;
    }
    // getting from api
    this.loadingStops = true
    api.get('/shipments/' + this.activeShipment.data.id + '/stops')
      .then(response => {
        this.loadingStops = false;
        if (!this.activeShipment) return
        this.activeShipment = Object.assign({}, this.activeShipment, {stops: response.data})
        if (callback) callback(response.data);
      });
  }

  getShipmentPOD() {
    if (!this.activeShipment || !this.activeShipment.data) {
      return;
    }
    // getting from api
    this.loadingStops = true
    api.get('/shipments/' + this.activeShipment.data.id + '/pod')
      .then(response => {
        this.loadingStops = false;
        if (!this.activeShipment) return
        this.activeShipment = Object.assign({}, this.activeShipment, {pod: response.data})
      });
  }

  getShipmentTracking() {
    if (!this.activeShipment || !this.activeShipment.data) {
      return;
    }
    api.get('/tracking/' + this.activeShipment.data.tracking_code + '/heartbeat')
      .then(response => {
        if (!this.activeShipment) return
        if (this.activeShipment.data && response.data.shipment && (this.activeShipment.data.id !== response.data.shipment.id)) {
          return;
        }
        // set type for tracking event
        var dropoff_event_start = null;
        var return_event_start = null;
        if (this.activeShipment.history && this.activeShipment.history.outbound_events) {
          this.activeShipment.history.outbound_events.forEach(e => {
            if (e.signal === 'PICKUP_SUCCEEDED') {
              dropoff_event_start = e.ts;
            } else if (e.signal === 'DROPOFF_SUCCEEDED' || e.signal === 'DROPOFF_FAILED') {
              return_event_start =  e.ts;
            } else if (e.signal === 'RETURN_EN_ROUTE' && return_event_start === null) {
              return_event_start = e.ts;
            } else if (e.signal === 'RETURN_READY' && return_event_start === null) {
              return_event_start = e.ts;
            }
          });
        }
        if (!response.ok) return;
        this.activeShipment.tracking = response.data.reverse().map(e => {
          if (dropoff_event_start === null || e.ts <= dropoff_event_start) {
            return e;
          }
          if (return_event_start === null || e.ts < return_event_start) {
            e.event_type = 'dropoff';
          } else {
            e.event_type = 'return';
          }
          return e;
        })
      })
  }

  saveShipment(shipment, callback) {
    api.post('/shipments', shipment)
      .then(callback)
  }

  updateShipment(id, shipment, callback) {
    api.put(`/shipments/${id}`, shipment)
      .then(callback)
  }

  loadShipment(shipmentId, callback) {
    api.get(`/shipments/${shipmentId}`).then(callback);
  }

  geocodeShipment(shipment, isDropoff, callback) {
    this.geocodingShipment = true;
    api.post('/shipments/geocode', shipment, {params: {is_dropoff: isDropoff}}).then(response => {
      if (callback) callback(response.data);
      this.geocodingShipment = false;
    })
  }

  search(keyword, callback, fallback) {
    this.searchingShipment = true;
    const searchKey = encodeURIComponent(keyword.trim());
    api.get(`/shipments/search/${searchKey}`).then(response => {
      if (response.status === 200) {
        this.preFilled = true;
        if (callback) callback(response.data);
      } else {
        if (fallback) fallback();
      }
      this.searchingShipment = false;
    });
  }

  getLabel(shipmentId, format, callback) {
    if (format === 'PNG' || format === 'PDF') {
      api.get(`/shipments/${shipmentId}/label?format=${format}`).then(callback);
    } else {
      api.get(`/shipments/${shipmentId}/label`).then(callback);
    }
  }

  csv(cb) {
    const filters = toJS(this.ordering);
    const searchCriteria = toJS(this.searchCriteria);

    if (!_.isEmpty(searchCriteria)) {
      const key = Object.keys(searchCriteria)[0]
      filters['search_field'] = key;
      filters['search_value'] = searchCriteria[key];
    }

    if (this.filterDate) {
      filters['date'] = this.filterDate;
    }

    if (this.serviceLevel) {
      filters['service_level'] = this.serviceLevel;
    }

    this.downloadingCsv = true;
    api.post('/shipments/csv', filters).then(response => {
      this.downloadingCsv = false;
      if (response.status === 200) {
        cb(response.data);
      }
    });

    console.log('search critical: ', this.searchCriteria);
  }

  updateDropoffLocationInfo(shipment, cb) {
    this.updating = true;
    const DAC = this.shipmentDropoffForm.data.dropoff_access_code;
    const DAI = this.shipmentDropoffForm.data.dropoff_additional_instruction;

    // Valid
    this.shipmentDropoffForm.data.dropoff_access_code            = (DAC && DAC.trim() !== '') ? DAC : '';
    this.shipmentDropoffForm.data.dropoff_additional_instruction = (DAI && DAI.trim() !== '') ? DAI : '';
    api.put(`/shipments/${shipment.id}/dropoff-location-info`, this.shipmentDropoffForm.data).then((response) => {
      this.updating = false;
      if (cb) {
        cb(response.data);
      }
    })
  }

  getShipmentLatestFeedback(shipmentId, callback) {
    this.loadingModal = true;
    api.get(`/shipments/${shipmentId}/feedback`).then(response => {
      if (response.ok) {
        const {data} = response;
        if (data.id) {
          this.feedbackForm.setData(data);
        } else {
          if (typeof data === 'number') {
            this.feedbackForm.setField('stop_id', data);
          }
        }

        if (callback) callback(response);
      }
      this.loadingModal = false;
    });
  }

  submitFeedback(shipmentId, callback) {
    const stopId = this.feedbackForm.getField('stop_id');
    if (!stopId) {
      return false;
    }

    this.loadingModal = true;
    api.post(`/shipments/${shipmentId}/feedback/${stopId}`, this.feedbackForm.data).then(response => {
      if (callback) callback(response);
      this.loadingModal = false;
    });
  }

  @observable cancelingShipment = false;
  cancelShipment(shipmentId, reason, callback) {
    this.cancelingShipment = true;
      api.post(`/shipments/${shipmentId}/cancel`, {reason}).then((r1) => {
        if (r1.status < 300) {
          return api.get('/shipments/' + shipmentId)
            .then(response => {
              this.activeShipment = {
                error: false,
                data: response.data
              }
              this.getShipmentStops(() => {
                this.cancelingShipment = false;
                if (callback) callback();
              });
            })
        }
      });
  }

  @observable cloning = false;
  cloneShipment(shipmentId, callback) {
    this.cloning = true;
    api.post(`/shipments/${shipmentId}/clone`).then((res) => {
      if (res.ok) {
        // success clone
      }
      if (callback) callback(res);
      this.cloning = false;
    });
  }

  updateDropoffAddress(field, val) {
    this.activeShipment = {
      ...this.activeShipment,
      data: {
        ...this.activeShipment.data,
        dropoff_address: {
          ...this.activeShipment.data.dropoff_address,
          [field]: val
        }
      }
    }
  }

  updateField(field, val) {
    this.activeShipment = {
      ...this.activeShipment,
      data: {
        ...this.activeShipment.data,
        [field]: val
      }
    }
  }
}

export default ShipmentStore;
